<template>
    <div id="vehicleAutoCheck">
        <iframe id="autocheckIframe" :src="src" :title="title" scrolling="no">
        </iframe>
    </div>
</template>

<script>
    export default {
        computed: {
            vehicle() {
                return this.$store.getters.vehicleGallerySelected;
            },
            src() {
                return this.$store.getters.getAppUrlByName('autocheck') + this.vehicle.StockNumber; 
            },
            title() {
                return "Autocheck for " + this.vehicle.Year + " " + this.vehicle.Make + " " + this.vehicle.Model + " " + this.vehicle.StockNumber;
            },
            autocheckHeight() {
                return this.$store.getters.getAutocheckDocHeight;
            }
        },
        watch: {
            autocheckHeight(current, previous) {
                if(current != previous && current) {
                    var div = document.getElementById("autocheckIframe");
                    div.style.height = this.autocheckHeight;
                }
            }
        }
    }
</script>

<style>
    #vehicleAutoCheck {
        width: inherit;
        height: fit-content;
        background-color: white;
        overflow-y: scroll;
        overflow-x: hidden;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    #autocheckIframe {
        width: inherit;
        min-height: calc(80 * var(--vh));
    }
</style>